export const SUPPORT_EMAIL = "cemzebrai@gmail.com";
